import styled from 'styled-components';

const Wrapper = styled.div`
    margin-inline: auto;
    width: min(100%, 80rem);
    flex: 1;
    padding: 1rem;
`;

export default Wrapper;